'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _mediaButton = require('../../../../atoms/media-button');

var _mediaButton2 = _interopRequireDefault(_mediaButton);

var _appBadges = require('../../../../atoms/app-badges');

var _appBadges2 = _interopRequireDefault(_appBadges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'pullout';

var getAlignment = function getAlignment(textAlign) {
  var alignment = {
    left: 'col-xs-12 col-lg-8 text-xs-center text-md-left',
    right: 'col-xs-12 col-lg-10 text-xs-center text-md-right',
    center: 'col-xs-12 col-lg-10 center-block text-xs-center'
  };
  return alignment[textAlign || 'center'];
};

var renderContent = function renderContent(paragraph) {
  if (paragraph) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__paragraph pp-sans-big-light' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderLink = function renderLink(link) {
  if (link) {
    var linkTarget = void 0;
    if (link.target) {
      linkTarget = '' + link.target;
    }

    return _react2.default.createElement(
      'a',
      {
        href: link.href,
        target: linkTarget,
        className: ORGANISM_NAME + '__link',
        'data-pa-click': 'Pullout-Link-' + (link.fpti || link.text)
      },
      link.text
    );
  }
  return null;
};

var renderHatchContent = function renderHatchContent(hatchText) {
  if (hatchText) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__hatch-text legal-notes' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var Pullout = function (_React$Component) {
  _inherits(Pullout, _React$Component);

  function Pullout(props) {
    _classCallCheck(this, Pullout);

    var _this = _possibleConstructorReturn(this, (Pullout.__proto__ || Object.getPrototypeOf(Pullout)).call(this, props));

    _this.getAlignment = getAlignment;
    _this.renderContent = renderContent;
    _this.renderLink = renderLink;
    _this.renderHatchContent = renderHatchContent;
    _this.sectionElement = null;
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.state = {
      showImages: false
    };
    return _this;
  }

  _createClass(Pullout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'renderImage',
    value: function renderImage(image) {
      if (this.state.showImages && image) {
        return _react2.default.createElement('img', { src: image.src, className: ORGANISM_NAME + '__image', alt: image.alt });
      }
      return null;
    }
  }, {
    key: 'renderHeadline',
    value: function renderHeadline(headline) {
      if (headline) {
        var fontSize = this.props.config.isLongHeadline ? 'h3' : '';

        var fontClass = (0, _classnames2.default)(ORGANISM_NAME + '__headline', '' + fontSize);
        return _react2.default.createElement(
          _heading2.default,
          { level: '2', className: fontClass },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }
  }, {
    key: 'renderCTA',
    value: function renderCTA(cta) {
      if (cta) {
        var targetValue = cta.target || '_self';
        var align = this.props.config.textAlign || 'center';
        var color = cta.color || 'blue';
        var buttonClass = (0, _classnames2.default)(ORGANISM_NAME + '__btn', ORGANISM_NAME + '__btn--' + align, 'pypl-btn--' + color);

        return _react2.default.createElement(
          _button2.default,
          {
            id: cta.id,
            href: cta.href,
            className: buttonClass,
            fpti: 'Pullout-Prmrycta-' + (cta.fpti || cta.text),
            target: targetValue
          },
          cta.text
        );
      }
      return null;
    }
  }, {
    key: 'renderMediaButton',
    value: function renderMediaButton(mediaButton) {
      if (mediaButton) {
        var align = this.props.config.textAlign || 'center';
        var color = mediaButton.color || 'outline-blue';
        var buttonClass = (0, _classnames2.default)(ORGANISM_NAME + '__media-btn', ORGANISM_NAME + '__btn--' + align, 'pypl-btn--' + color);

        return _react2.default.createElement(
          _mediaButton2.default,
          {
            id: mediaButton.id,
            color: 'outline-blue',
            className: buttonClass,
            fpti: 'Pullout-MediaBtn-' + (mediaButton.fpti || mediaButton.text),
            'data-video-id': mediaButton['data-video-id']
          },
          mediaButton.text
        );
      }
      return null;
    }
  }, {
    key: 'renderBadge',
    value: function renderBadge(clientInfo) {
      if (this.props.config.appBadge) {
        var appBadgeContent = {
          clientInfo: clientInfo,
          ios: this.props.content.ios,
          android: this.props.content.android
        };
        return _react2.default.createElement(_appBadges2.default, appBadgeContent);
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className,
          clientInfo = _props.clientInfo;
      var image = content.image,
          headline = content.headline,
          paragraph = content.paragraph,
          cta = content.cta,
          mediaButton = content.mediaButton,
          link = content.link,
          hatchText = content.hatchText;


      var viewport = clientInfo.client_type;

      var backgroundImage = config.backgroundImage && (config.backgroundImage[viewport] || config.backgroundImage.url);

      var backgroundPosition = config.backgroundImage && config.backgroundPosition;

      var backgroundImageStyle = this.state.showImages && backgroundImage ? {
        backgroundImage: 'url(' + backgroundImage + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;

      var pulloutClasses = (0, _classnames2.default)('' + ORGANISM_NAME, className, config.theme);

      return _react2.default.createElement(
        'section',
        {
          className: pulloutClasses,
          id: this.props.config.id,
          'data-building-block': 'organism',
          style: backgroundImageStyle,
          ref: function ref(el) {
            _this2.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: getAlignment(config.textAlign) },
              this.renderImage(image),
              this.renderHeadline(headline),
              renderContent(paragraph),
              this.renderCTA(cta),
              this.renderMediaButton(mediaButton),
              this.renderBadge(clientInfo),
              renderLink(link),
              renderHatchContent(hatchText)
            )
          )
        )
      );
    }
  }]);

  return Pullout;
}(_react2.default.Component);

exports.default = Pullout;


Pullout.propTypes = {
  clientInfo: _propTypes2.default.shape({
    client_os_type: _propTypes2.default.string,
    client_is_mobile: _propTypes2.default.bool,
    client_type: _propTypes2.default.string
  }),
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light', 'theme-background-image-dark', 'theme-background-image-light']).isRequired,
    textAlign: _propTypes2.default.oneOf(['left', 'right', 'center', '']),
    appBadge: _propTypes2.default.bool,
    isLongHeadline: _propTypes2.default.bool,
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      portable: _propTypes2.default.string.isRequired,
      mobile: _propTypes2.default.string.isRequired
    }),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right'])
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    cta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string,
      text: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    image: _propTypes2.default.shape({
      src: _propTypes2.default.string
    }),
    mediaButton: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      text: _propTypes2.default.string.isRequired,
      'data-video-id': _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    }),
    link: _propTypes2.default.shape({
      href: _propTypes2.default.string,
      text: _propTypes2.default.string,
      target: _propTypes2.default.string,
      fpti: _propTypes2.default.string
    }),
    ios: _propTypes2.default.shape({
      href: _propTypes2.default.string
    }),
    android: _propTypes2.default.shape({
      store: _propTypes2.default.oneOf(['google', 'android-store']),
      href: _propTypes2.default.string
    })
  }),
  className: _propTypes2.default.string
};

Pullout.defaultProps = {
  clientInfo: {
    client_os_type: 'ios',
    client_is_mobile: true,
    client_type: 'dedicated'
  },
  config: {
    id: '',
    textAlign: 'center',
    appBadge: true,
    theme: 'theme-background-color-white',
    backgroundPosition: 'center'
  },
  content: {
    headline: {
      text: 'Fewer than 25 characters fit on one line in mobile.'
    },
    paragraph: {
      text: 'Fewer than 100 characters total to equal less than 3 lines in mobile.'
    },
    cta: {
      text: 'Fewer Than 29 Characters Max',
      href: '#',
      'data-pa-click': 'cta|CTA Text',
      target: '_self'
    },
    hatchText: {
      text: 'Fewer than 34 characters per line'
    },
    link: {
      text: 'Less than 28 characters max',
      href: '#',
      target: '_blank',
      'data-pa-click': 'link|Link Text'
    },
    mediaButton: {
      text: 'This is Media Button',
      'data-video-id': 'rquuf4XfwLA'
    },
    logo: {
      src: 'https://www.paypalobjects.com/webstatic/en_CA/mktg/where-to-use-paypal/fashion/Adidas.png',
      alt: ''
    },
    ios: {
      href: 'https://app.adjust.com/vlx5gy'
    },
    android: {
      store: 'google',
      href: 'https://app.adjust.com/vxullh'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/pullout/main/jsx/Pullout.js
// module id = 433
// module chunks = 4